global.Print = function(element) {
  element.click(function(event) {
    window.print();
  });
};




